// The sender might have the "Foo Bar <foo@bar.com>;" format
export function getSenderDisplayName(sender: string): string {
    if (!sender) {
        return 'Unknown sender'; //TODO localize
    }

    const start: number = sender.lastIndexOf('<');
    if (start <= 0) {
        return sender;
    }

    return sender.substr(0, start).trim();
}
